import React from "react";
import ReactPaginate from "react-paginate";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const PaginationPortal = ({
  handlePageClick,
  pageCount,
  limit,
  currentPage,
}) => {
  // Menghitung nilai entriesStart dan entriesEnd
  let totalItems = pageCount;
  let forPageCount = Math.ceil(pageCount / limit);

  return (
    <div className="flex flex-col md:flex-row md:justify-center ">
      {forPageCount !== false && (
        <ReactPaginate
          className="items-center flex justify-center space-x-1 list-none"
          previousLabel={<IoIosArrowBack className="inline" />}
          nextLabel={<IoIosArrowForward className="inline" />}
          breakLabel={"..."}
          pageCount={forPageCount}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={(e) => handlePageClick(e)}
          containerClassName="pagination flex items-center justify-center mt-6"
          pageClassName="inline-block mx-1"
          previousClassName={`inline-block mx-1 ${
            totalItems === 0 ? "hidden" : ""
          }`}
          nextClassName={`inline-block mx-1 ${
            totalItems === 0 ? "hidden" : ""
          }`}
          previousLinkClassName="px-3 py-1 border border-gray-300 text-blue-600 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-500"
          nextLinkClassName="px-3 py-1 border border-gray-300 text-blue-600 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-500"
          pageLinkClassName="px-3 py-1 border border-gray-300 text-blue-600 dark:text-white hover:bg-sky-500 hover:text-white dark:hover:bg-gray-500"
          activeLinkClassName="bg-sky-500 text-white cursor-default "
          disabledLinkClassName="hidden"
          renderOnZeroPageCount={null}
          forcePage={currentPage}
        />
      )}
    </div>
  );
};
export default PaginationPortal;
